// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"MjtLAvp3","root":"TjUOeqy0","companyItemWrapper":"ksIHCTg2","wrapper":"YFQH06Ll","styledButtonLink":"NDOfuSGK"};